<template>
  <div>
    <b-table
      show-empty
      bordered
      small
      stacked="md"
      head-variant="light"
      :items="reImport.data || []"
      :fields="fields"
      responsive="sm"
      :busy="isLoading"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" variant="yellow" />
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <div class="text-center">
          <b-icon
            icon="check-square"
            v-b-tooltip.hover
            title="Complete re-import"
            class="h5 m-2 cursor-pointer"
            @click="completeReImport(row.item)"
          ></b-icon>
          <b-icon
            icon="trash"
            v-b-tooltip.hover
            title="Delete"
            class="h5 m-2 cursor-pointer"
            @click="deleteReImport(row.item)"
          ></b-icon>
        </div>
      </template>
    </b-table>

    <b-pagination
      v-if="!isLoading && reImport && reImport.total > 0"
      :value="reImport.currentPage"
      :total-rows="reImport.total"
      :per-page="reImport.perPage"
      class="mb-2"
      align="end"
      @change="changePage($event)"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  DELETE_REIMPORT,
  GET_REIMPORT_DATA_BY_VIN,
  PUT_COMPLETE_REIMPORT,
} from "./actions";
import { generalMixin } from "@/modules/mixin.js";
import { superAdminMixin } from "../mixins";
export default {
  name: "ReImportTableByVin",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  mixins: [generalMixin, superAdminMixin],

  computed: {
    ...mapState({
      reImportData: (state) =>
        state.superAdminStore.reImport.reImportDataByVin || {
          data: [],
          total: 0,
          currentPage: 1,
          perPage: 10,
        },
      isLoading: (state) =>
        state.superAdminStore.reImport.reImportDataByVin.status === "fetching",
    }),

    reImport() {
      return this.reImportData.data || [];
    },
  },
  data() {
    return {
      fields: [
        {
          key: "stockNumber",
          label: "Stock Number",
          class: "text-center",
        },
        {
          key: "vinNumber",
          label: "VIN",
          class: "text-center",
        },
        {
          key: "year",
          label: "Year",
          class: "text-center",
        },
        {
          key: "make",
          label: "Make",
        },
        {
          key: "model",
          label: "Model",
        },
        {
          key: "color",
          label: "Color",
        },
        {
          key: "actions",
          label: "Actions",
          class: "text-center",
        },
      ],
    };
  },
  watch: {
    status(newVal, oldVal) {
      if (newVal !== oldVal) {
        console.log("Status changed from", oldVal, "to", newVal);
        this.getData();
      }
    },
  },

  methods: {
    getData(filter = "") {
      console.log(
        "Fetching reimport data by VIN with status:",
        this.status,
        "and filter:",
        filter
      );

      this.$store
        .dispatch(GET_REIMPORT_DATA_BY_VIN, {
          status: this.status,
          search: filter,
          page: this.reImportData.currentPage || 1,
        })
        .then(() => {
          console.log("Data loaded successfully");
        })
        .catch((error) => {
          console.error("Error loading reimport data by VIN:", error);
        });
    },
    completeReImport(item) {
      this.$store
        .dispatch(PUT_COMPLETE_REIMPORT, { vehicleId: item.id })
        .then(() => {
          this.makeToast(
            "Success",
            "Re-import completed successfully",
            "success"
          );
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("Internal server error, try again later", {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    async deleteReImport(item) {
      const confirm = await this.showConfirmDeleteBox();
      if (!confirm) return;
      this.$store
        .dispatch(DELETE_REIMPORT, { vehicleId: item.id })
        .then(() => {
          this.makeToast(
            "Success",
            "Re-import deleted successfully",
            "success"
          );
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("Internal server error, try again later", {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    changePage(page) {
      this.$store
        .dispatch(GET_REIMPORT_DATA_BY_VIN, {
          status: this.status,
          search: "",
          page: page,
        })
        .then(() => {
          console.log("Page changed successfully");
        })
        .catch((error) => {
          console.error("Error changing page:", error);
        });
    },
  },
};
</script>
